import { ICartEntry } from 'features/cart/types';
import { calculateEntryTotalPrice } from 'features/cart/utils';
import { StyleSheet, Text, View } from 'react-native';

import { t } from 'state/intl/translations';
import { useUIContext } from 'state/ui';
import { primitive } from 'styles/constants/primitives';

import { CartEntryDeleteButton } from '../cart-actions/cart-entry-delete-button';
import { CartEntryDuplicateButton } from '../cart-actions/cart-entry-duplicate-button';
import { CartEntryEditButton } from '../cart-actions/cart-entry-edit-button';
import { CartEntryRewardActionButton } from '../cart-actions/cart-entry-reward-action-button';

export const CartEntryFooter = ({
  cartEntry,
  isLoading,
}: {
  cartEntry: ICartEntry;
  isLoading?: boolean;
}) => {
  const { formatCurrencyForLocale } = useUIContext();
  const entryTotalPrice = calculateEntryTotalPrice(cartEntry);

  return (
    <View style={styles.footer}>
      <CartEntryDeleteButton cartEntry={cartEntry} disabled={isLoading} variant="iconOnly" />
      <CartEntryDuplicateButton cartEntry={cartEntry} disabled={isLoading} />
      <CartEntryEditButton cartEntry={cartEntry} disabled={isLoading} />

      <View style={{ flex: 1 }} />

      <CartEntryRewardActionButton cartEntry={cartEntry} isLoading={isLoading} />
      <Text style={styles.editText}>
        {entryTotalPrice === 0 ? t('free') : formatCurrencyForLocale(entryTotalPrice)}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  footer: {
    flexDirection: 'row',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderTopWidth: 1,
    borderTopColor: primitive.$blackOpacity10,
    alignItems: 'center',
    gap: 16,
  },
  editText: {
    fontSize: 14,
    fontWeight: 'bold',
    fontFamily: primitive.fontFamily.$headers,
    color: primitive.bk.$bbqBrown,
  },
});
